<template>
  <div>
    <v-container fluid grid-list-lg class="pa-2" :style="{ width: '100% !important' }">
      <v-layout wrap>
        <v-spacer></v-spacer>
        <v-flex shrink>
          <v-btn @click="handleSearchButtonClick">
            <v-icon>search</v-icon>
            Search
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <Overview class="mt-4">
      <template #chart>
        <Chart
          :positive-count="stats.positiveCount"
          :negative-count="stats.negativeCount"
          :neutral-count="stats.neutralCount"
        />
      </template>
      <template #newComment>
        <StatCounter title="New Comment" :loading="loading" :value="stats.newCommentCount" />
      </template>
      <template #hideReplyComment>
        <StatCounter
          title="Hide Reply Comment"
          :loading="loading"
          :value="stats.hideReplyCommentCount"
        />
      </template>
    </Overview>

    <DataTable
      :items="dataTable.items"
      :pagination.sync="dataTablePagination"
      class="mt-4"
      @export="handleDataTableExport"
      @view="handleDataTableView"
      @update:pagination="handleDataTablePaginationUpdate"
    />

    <SearchDialog
      v-model="searchDialog.data"
      :open.sync="searchDialog.isOpen"
      @input="handleSearchDialogInput"
    />

    <UserDialog
      :open.sync="userDialog.isOpen"
      :userid="userDialog.userid"
      :pageid="userDialog.pageid"
      :page-name="userDialog.pageName"
      @handleGetUser="handleUserDialogGetUser"
    >
      <template v-if="userDialog.isOpen">
        <UserDataTable
          :userid="userDialog.userid"
          :pageid="userDialog.pageid"
          :pagination.sync="userdataTablePagination"
          @update:items="handleUpdateData"
          @export="handleUserDataTableExport"
          @update:pagination="handleUserDataTablePaginationUpdate"
          @change:sentiment="handleUserDataTableSentimentChange"
          @change:hasRemarked="handleUserDataTableRemarkStateChange"
          @change:remark="handleUserDataTableRemarkChange"
        />
      </template>
    </UserDialog>
  </div>
</template>

<script>
import moment from 'moment'
import { DATETIME } from '@/constants/datetime'
import Overview from './Overview.vue'
import Chart from './Chart.vue'
import StatCounter from './StatCounter.vue'
import DataTable from './DataTable.vue'
import SearchDialog from './SearchDialog.vue'
import UserDialog from './UserDialog.vue'
import UserDataTable from './UserDataTable.vue'
import ttbApi from '@/api/ttb'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'

export default {
  name: 'ReplyComment',
  components: {
    Overview,
    Chart,
    StatCounter,
    DataTable,
    SearchDialog,
    UserDialog,
    UserDataTable
  },
  data() {
    return {
      loading: true,
      stats: {
        positiveCount: 0,
        negativeCount: 0,
        neutralCount: 0,
        newCommentCount: 0,
        hideReplyCommentCount: 0
      },
      dataTable: {
        items: []
      },
      dataTablePagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        sortBy: null,
        descending: null
      },
      searchDialog: {
        isOpen: false,
        data: {
          dateRange: {
            start: moment().format(DATETIME.DATE_FORMAT),
            end: moment().format(DATETIME.DATE_FORMAT),
            filter: 'today'
          },
          name: '',
          sentiment: '',
          page: '',
          totalNegative: ''
        }
      },
      userDialog: {
        isOpen: false,
        userid: '',
        pageid: '',
        user: null,
        pageName: ''
      },
      userDataTable: {
        items: Array(10)
          .fill()
          .map((value, index) => ({
            id: index + 1,
            datetime: moment().toISOString(),
            message: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, qui!',
            post: 'Post',
            sentiment: ['neutral', 'positive', 'negative'][Math.floor(Math.random() * 3)],
            hasRemarked: Math.random() >= 0.5,
            remark: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Enim, nisi.'
          })),
        pagination: {
          page: 1,
          totalItems: 100
        }
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },

  async mounted() {
    this.loading = true
    await this.handleGetCountCommentAndSentiment()
    this.loading = false
  },
  methods: {
    async handleInit() {
      this.loading = true
      await this.handleGetCountCommentAndSentiment()
      await this.handleGetSentimentByUser()
      this.loading = false
    },
    async handleGetCountCommentAndSentiment() {
      const response = await ttbApi.getCountCommentAndSentiment({
        params: {
          page_id: this.selectedBot.pageid,
          start_date:
            this.searchDialog.data && this.searchDialog.data.dateRange
              ? this.searchDialog.data.dateRange.start
              : undefined,
          end_date:
            this.searchDialog.data && this.searchDialog.data.dateRange
              ? this.searchDialog.data.dateRange.end
              : undefined,
          search_page_id: this.searchDialog.data.page || undefined
        }
      })
      if (response.status == 200) {
        const positive = response.data.sentiment
          ? response.data.sentiment.find((item) => item.sentiment == 'positive')
          : undefined

        const negative = response.data.sentiment
          ? response.data.sentiment.find((item) => item.sentiment == 'nagative')
          : undefined

        const neutral = response.data.sentiment
          ? response.data.sentiment.find((item) => item.sentiment == 'neutral')
          : undefined
        this.stats.positiveCount = positive
          ? typeof positive.count == 'string'
            ? parseInt(positive.count)
            : positive.count
          : 0
        this.stats.negativeCount = negative
          ? typeof negative.count == 'string'
            ? parseInt(negative.count)
            : negative.count
          : 0
        this.stats.neutralCount = neutral
          ? typeof neutral.count == 'string'
            ? parseInt(neutral.count)
            : neutral.count
          : 0
        this.stats.newCommentCount = response.data.comment
          ? response.data.comment.count_all || 0
          : 0
        this.stats.hideReplyCommentCount = response.data.comment
          ? response.data.comment.count_hidecomment || 0
          : 0
      } else {
        this.stats.positiveCount = 0
        this.stats.negativeCount = 0
        this.stats.neutralCount = 0
        this.stats.newCommentCount = 0
        this.stats.hideReplyCommentCount = 0
      }
    },
    async handleGetSentimentByUser() {
      const response = await ttbApi.getSentimentByUser({
        params: {
          page_id: this.selectedBot.pageid,
          start_date:
            this.searchDialog.data && this.searchDialog.data.dateRange
              ? this.searchDialog.data.dateRange.start
              : undefined,
          end_date:
            this.searchDialog.data && this.searchDialog.data.dateRange
              ? this.searchDialog.data.dateRange.end
              : undefined,
          search_page_id: this.searchDialog.data.page || undefined,
          sentiment: this.searchDialog.data.sentiment || undefined,
          name: this.searchDialog.data.name || undefined,
          all_nagative:
            this.searchDialog.data.sentiment == 'nagative' &&
            this.searchDialog.data.totalNegative == 'gte_4'
              ? false
              : true,
          limit: this.dataTablePagination.rowsPerPage,
          offset: (this.dataTablePagination.page - 1) * this.dataTablePagination.rowsPerPage
        }
      })

      if (response.status == 200) {
        this.dataTablePagination.totalItems = Number(response.data.total || 0)
        this.dataTable = {
          items: response.data.data,
          pagination: {
            ...this.dataTablePagination,
            totalItems: Number(response.data.total || 0)
          }
        }
      } else {
        this.dataTable = {
          items: [],
          totalItems: 0
        }
      }
    },
    handleSearchButtonClick() {
      this.searchDialog.isOpen = true
    },
    async handleDataTableExport() {
      const date = XLSX.utils.aoa_to_sheet([
        [
          `From ${
            this.searchDialog.data.dateRange.start
              ? moment(this.searchDialog.data.dateRange.start).format('DD/MM/YYYY')
              : ''
          } to ${
            this.searchDialog.data.dateRange.end
              ? moment(this.searchDialog.data.dateRange.end).format('DD/MM/YYYY')
              : ''
          }`
        ]
      ])
      const items = this.dataTable.items || []
      const data = XLSX.utils.json_to_sheet(
        items.map((el) => ({
          'Customer Name': `${el.first_name} ${el.last_name}`,
          'Date & Time': el.timestamp ? moment(el.timestamp).format(DATETIME.DATETIME_FORMAT) : '',
          Page: el.pageid,
          Post: el.post_id,
          Message: el.message,
          'Last Sentiment': el.sentiment,
          'Total Nagative': el.total_nagative
        }))
      )

      let a = XLSX.utils.sheet_to_json(date, { header: 1 })
      let b = XLSX.utils.sheet_to_json(data, { header: 1 })

      a = a.concat(['']).concat(b)

      let worksheet = XLSX.utils.json_to_sheet(a, { skipHeader: true })
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, worksheet)
      XLSX.writeFile(wb, `sentiment_report.xlsx`)
    },
    handleDataTableView(item) {
      this.userDialog.userid = item.user_id
      // this.userDialog.pageid = item.pageid
      this.userDialog.pageName = item.pagename
      this.userDialog.pageid = this.selectedBot.pageid
      this.userDialog.isOpen = true
    },
    handleDataTablePaginationUpdate(value) {
      this.dataTablePagination = {
        ...this.dataTablePagination,
        ...value
      }
      this.handleGetSentimentByUser()
    },
    handleSearchDialogInput(value) {
      this.handleInit()
    },
    handleUserDialogGetUser(user) {
      this.userDialog.user = user
    },
    handleUserDataTableExport(items) {
      const date = XLSX.utils.aoa_to_sheet([
        [
          this.userDialog.user
            ? `${this.userDialog.user.first_name} ${this.userDialog.user.last_name}`
            : ''
        ],
        [`Page: ${this.userDialog.pageid}`]
      ])

      const data = XLSX.utils.json_to_sheet(
        items.map((el) => ({
          'Date & Time': el.timestamp ? moment(el.timestamp).format(DATETIME.DATETIME_FORMAT) : '',
          Message: el.message,
          Post: el.post_id,
          Sentiment: el.sentiment,
          Remark: el.remark
        }))
      )

      let a = XLSX.utils.sheet_to_json(date, { header: 1 })
      let b = XLSX.utils.sheet_to_json(data, { header: 1 })

      a = a.concat(['']).concat(b)

      let worksheet = XLSX.utils.json_to_sheet(a, { skipHeader: true })
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, worksheet)
      XLSX.writeFile(wb, `sentiment_by_user_report.xlsx`)
    },
    handleUpdateData() {
      this.handleGetSentimentByUser()
    },
    handleUserDataTablePaginationUpdate(value) {
      //
    },
    handleUserDataTableSentimentChange(value) {
      //
    },
    handleUserDataTableRemarkStateChange(value) {
      //
    },
    handleUserDataTableRemarkChange(value) {
      //
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/index.vue